import { AxiosService } from './';

const getListTaxOverview = async (_perPage, _page, commonSearch, year) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/tax_overview/list',
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        year: year,
        //  status: status
      },
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const generateTaxOverview = async () => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/tax_overview',
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

export { getListTaxOverview, generateTaxOverview };
